import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const get_all_plans = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/`,
        method: "GET"
    })
}

export const create_new_plan = async (plan_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/`,
        method: "POST",
        body: JSON.stringify(plan_data)
    })
}

export const update_plan = async (plan_id, plan_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/id/${plan_id}`,
        method: "PUT",
        body: JSON.stringify(plan_data)
    })
}

export const delete_plan = async (plan_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/id/${plan_id}`,
        method: "DELETE"
    })
}

export const get_plan_by_plan_id = async (plan_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/id/${plan_id}`,
        method: "GET"
    })
}

export const update_plan_components = async (components_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/components`,
        method: "PUT",
        body: JSON.stringify(components_data)
    })
}

export const get_all_plan_components = async (plan_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/components/id/${plan_id}`,
        method: "GET"
    })
}

export const update_plan_sections = async (sections_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/sections`,
        method: "PUT",
        body: JSON.stringify(sections_data)
    })
}

export const enroll_plan = async (plan_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/enroll`,
        method: "POST",
        body: JSON.stringify({ plan_id })
    })
}

export const check_enrolment_status = async (plan_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/enrolled/${plan_id}`,
        method: "GET"
    })
}

export const get_all_plans_user_enrolled = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/enrolled`,
        method: "GET"
    })
}

export const get_all_published_plans = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/published`,
        method: "GET"
    })
}

export const get_published_plan_by_plan_id = async (plan_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/published/id/${plan_id}`,
        method: "GET"
    })
}

export const mark_step_as_completed = async (completion_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/plan/completion`,
        method: "POST",
        body: JSON.stringify(completion_data)
    })
}
